import AddIcon from '@mui/icons-material/Add';
import { Fab } from '@mui/material';
import { useNavigate } from 'react-router';
import { PageContent } from '../../components/core/PageContent/PageContent';
import { PageHeader } from '../../components/core/PageHeader/PageHeader';
import { useAuth } from '../../contexts/authWindows';
import { useTranslation } from '../../contexts/translation';
import { UserRoles } from '../../types/core/auth.types';
import { paths } from '../../utils/core/routes';
import { EmailReportList } from './EmailReportList';
export function EmailReportPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const isReadOnly =
    user?.roles.includes(UserRoles.Admin) || user?.roles.includes(UserRoles.EmailReports)
      ? false
      : true;
  const headerButtons = [
    <Fab
      key={0}
      color="primary"
      aria-label="add"
      size="medium"
      onClick={() => {
        navigate(paths.EMAIL_REPORT_CREATE);
      }}
    >
      <AddIcon />
    </Fab>,
  ];
  return (
    <>
      <PageHeader
        title={t('page.email-report.main-headline')}
        buttons={isReadOnly ? null : headerButtons}
        xs={6}
      />
      <PageContent>
        <EmailReportList isReadOnly={isReadOnly} />
      </PageContent>
    </>
  );
}
